export default __webpack_public_path__ + "static/media/display.d32080cf.svg";